import { AxiosResponse } from 'axios'
import moment, { Moment } from 'moment'
import { RequestCDU, RequestREAD } from 'services/Instances'

export const GenerateCreServices = () => {
  const path = 'Carteira'

  const getCriarSimulacao = async (
    requestObj: ICriarSimulacao
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(`${path}/CriarSimulacao`, requestObj)

  const createCarteira = async (
    requestObj: ICriarSimulacao
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

    const includeCarteira = async (
      requestObj: IIncludeCarteira[]
    ): Promise<AxiosResponse> =>
      await RequestCDU.post(`${path}/Include`, requestObj)

  return { createCarteira, getCriarSimulacao, includeCarteira }
}

export interface IResponseCriarSimulacao {
  pageCount: number
  totalItemCount: number
  pageNumber: number
  pageSize: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  isFirstPage: boolean
  isLastPage: boolean
  firstItemOnPage: number
  lastItemOnPage: number
  items: any[]
}

export interface IIncludeCarteira {
  idMovimentacao: string,
  idUsuario: number
}
export interface ICriarSimulacao {
  pageNumber?: number
  pageSize?: number
  checkAll?: boolean
  paginacao: boolean
  searchQuery: string
  dataAtual: string | Date | Moment
  qtdCarteiraItens: number
  pesquisaGeral?: string
  nuPrimeiraMobilizacao?: string
  nuUltimaMedicao?: string
  nuDenuncia?: string
  nuProjeto?: string
  nuAlerta?: string
  nuUltimaAnalise?: string
  nuValorFolha?: string
  nuQtEfetivo?: string
  simulacao?: boolean
  carteiraItensInclude?: any[]
  // movimentacoesIdsExclude?: any[]
}
